/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const adminRoutes = {
  path: '/administrator',
  component: Layout,
  // redirect: '/administrator/users',
  name: 'Administrator',
  meta: {
    title: 'administrator',
    icon: 'admin',
    permissions: ['administrator view_menu']
    // roles: [
        // 'admin', 'manager'
    // ],
  },
  children: [
    {
      path: 'users',
      component: () => import('@/views/users/index'),
      name: 'UserList',
      meta: { title: 'users', icon: 'user', permissions: ['user_manager view_menu'] },
    },
    // {
    //   path: 'config',
    //   component: () => import('@/views/config/index'),
    //   name: 'Config',
    //   meta: { title: 'Cấu hình', icon: 'el-icon-s-operation', roles: ['admin'] },
    // },
    /** Role and permission */
    {
      path: 'roles',
      component: () => import('@/views/role-permission/List'),
        name: 'RoleList',
        meta: { title: 'rolePermission', icon: 'role',
        permissions: ['role_manager view_menu']

        // roles: ['admin']
      },
    },
    /** history */
    {
      path: 'user_histories',
      component: () => import('@/views/user_histories'),
        name: 'user_histories',
        meta: { title: 'Lịch sử người dùng', icon: 'education',
        permissions: ['user_histories view_menu']

        // roles: ['admin']
      },
    },
  ],
};
export default adminRoutes;
